import { getLeaderBoard } from 'apis/scoringVoucherAPI';
import useAsync from 'hooks/base/useAsync';
import { isNil } from 'lodash';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getItem } from 'utils/local-storage';
import { USER_PROFILE } from 'utils/storage-keys';

interface TokenParam {
  token: string;
}

const GetLeaderBoardApi = () => {
  const { status, execute, value } = useAsync(getLeaderBoard, false);
  const userProfile = !isNil(getItem(USER_PROFILE)) ? JSON.parse(getItem(USER_PROFILE) || '') : '';
  const navigate = useNavigate();

  React.useEffect(() => {
    execute(userProfile?.user_id);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [execute]);

  const getLeaderBoardApi = React.useCallback(
    (params: TokenParam) => {
      execute(params.token);
    },
    [execute]
  );

  React.useEffect(() => {
    if (isNil(value)) {
      return;
    }

    if (value.error) {
      // message.error(value.errorMessage);
      return;
    }

    // message.success('Load lessons and minutes success');
  }, [navigate, value]);

  return {
    isLoading: status === 'pending',
    getLeaderBoardApi,
    leaderBoard: value
  };
};

export default GetLeaderBoardApi;
